import { render, staticRenderFns } from "./seller-gq.vue?vue&type=template&id=0caaba01&scoped=true&"
import script from "./seller-gq.vue?vue&type=script&lang=js&"
export * from "./seller-gq.vue?vue&type=script&lang=js&"
import style0 from "./seller-gq.vue?vue&type=style&index=0&id=0caaba01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caaba01",
  null
  
)

export default component.exports